/**
 * The personal companion: a small 3D character each person names, who reads
 * their own day (tasks, calendar, leave, timer) and plans it with them.
 *
 * It is strictly one-to-one. The conversation belongs to the person who had
 * it, is never readable by a manager, HR or an admin (BRD §10.2), and the
 * companion only ever sees what that person could already see themselves.
 */
export const COMPANION_NAME_MAX = 24;
/** Hues the character can be painted in — the same curated ring as avatars. */
export const COMPANION_HUES = [222, 250, 276, 300, 330, 350, 12, 28, 160, 174, 190, 205];
//# sourceMappingURL=companion.js.map